<template>
    <v-tooltip style="display: none" bottom>
      <template v-slot:activator="{ on }">
        <button
          @click="$emit('click')"
          :class="!closeIcon ? 'outline-rounded-button mr-1' : 'rounded-button mr-1'"
          v-on="on"
        >
            <icon
                name="slash"
                :size="16"
            />
        </button>
      </template>
      <span>{{tooltipName}}</span>
    </v-tooltip>
</template>

<script>
export default {
  props: {
    tooltipName: {
      type: String,
      required: false
    },
    closeIcon: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="sass" scoped>
.outline-rounded-button
  border: #00995D 1px solid
  border-radius: 50px
  color: #00995D
  height: 26px
  width: 26px
  padding: 4px 4px
  transition: opacity .3s, background .3s
  &:hover
    opacity: 0.7
  &:active
    background: #00995E
    color: white

.rounded-button
  border: #00995D 0px solid
  border-radius: 50px
  color: #00995D
  height: 26px
  width: 26px
  padding: 5px 5px
  transition: opacity .3s, background .3s
  &:hover
    opacity: 0.7
  &:active
    background: #00995E
    color: white
</style>
